import React, { FC } from 'react';

type PropsT = {
  fill?: string;
};

const ArrowTopRightIconSmall: FC<PropsT> = ({ fill = 'currentColor' }) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="5" height="5" viewBox="0 0 5 5" fill="none">
    <path
      d="M0.759212 5L0 4.24127L3.20521 1.03492H0.797332L0.803685 0H5V4.19683H3.95807L3.96442 1.79365L0.759212 5Z"
      fill={fill}
    />
  </svg>
);

export default ArrowTopRightIconSmall;
import React, { FC } from 'react';

type PropsT = {
  fill?: string;
};

const ArrowTopRightIconSmall: FC<PropsT> = ({ fill = 'currentColor' }) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="5" height="5" viewBox="0 0 5 5" fill="none">
    <path
      d="M0.759212 5L0 4.24127L3.20521 1.03492H0.797332L0.803685 0H5V4.19683H3.95807L3.96442 1.79365L0.759212 5Z"
      fill={fill}
    />
  </svg>
);

export default ArrowTopRightIconSmall;
